import React from 'react';
import {
  ButtonDelete,
  FormFooterWrapper,
} from 'page/Application/ManageCompanyList/component/Form/FormFooterSubmit/styled';
import {
  ButtonOkStyle,
  ButtonStyle,
} from 'page/Application/ManageCompanyList/component/Form/styled';
import useMultiLanguageEditCompany from 'page/Application/ManageCompanyList/EditCompany/hook/useMultiLanguageEditCompany';
import { useNavigate } from 'react-router-dom';
import { MANAGE_COMPANY_LIST_PATH } from 'constant/appPath';

const FormFooterSubmit = ({
  textOk,
  textCancel,
  textDelete,
  onCancel,
  onFinish,
  onDelete,
  isDelete,
  isLoading,
  isLoadingSubmit,
  isDisable,
  isSolitonUser,
  searchKeywordState,
  filterDataState,
}) => {
  const { DETAIL_COMPANY_BUTTON_DELETE } = useMultiLanguageEditCompany();
  const navigate = useNavigate();
  return (
    <FormFooterWrapper>
      {isSolitonUser ? (
        <>
          <ButtonStyle
            style={{ minWidth: 126 }}
            disabled={false}
            onClick={() =>
              navigate(`/${MANAGE_COMPANY_LIST_PATH}`, {
                state: {
                  searchKeywordState: searchKeywordState,
                  filterDataState: filterDataState,
                },
              })
            }
          >
            {/*must have a span tag so there are no spaces between letters*/}
            <span> 戻る</span>
          </ButtonStyle>
        </>
      ) : (
        <>
          <ButtonOkStyle
            type="primary"
            htmlType="submit"
            onClick={onFinish}
            disabled={isLoadingSubmit || isDisable}
          >
            {/*must have a span tag so there are no spaces between letters*/}
            <span> {textOk}</span>
          </ButtonOkStyle>
          {isDelete && (
            <ButtonDelete
              disabled={isDisable}
              onClick={onDelete}
              loading={isLoading}
            >
              {/*must have a span tag so there are no spaces between letters*/}
              <span> {textDelete ?? DETAIL_COMPANY_BUTTON_DELETE}</span>
            </ButtonDelete>
          )}
          <ButtonStyle
            style={{ minWidth: 126 }}
            disabled={isDisable}
            onClick={onCancel}
          >
            {/*must have a span tag so there are no spaces between letters*/}
            <span> {textCancel}</span>
          </ButtonStyle>
        </>
      )}
    </FormFooterWrapper>
  );
};

export default FormFooterSubmit;
